import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { Row, Col, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import FormSelect from '../../../components/common/FormSelect';
import DateTime from 'react-datetime';
import {
    IStatisticsRegion,
    IStatisticsPhotographer,
    IStatisticsChain,
    IStatisticsFirm,
    IStatisticsSeller,
    IPeriodDate,
} from '../Entities';
import moment from 'moment';

interface IStatisticsContentProvider {
    id: number;
    name: string;
}

interface IStatisticsFilter {
    region: number;
    regions: IStatisticsRegion[];
    photographer: number;
    photographers: IStatisticsPhotographer[];
    chain: number;
    chains: IStatisticsChain[];
    firm: number;
    firms: IStatisticsFirm[];
    seller: number;
    sellers: IStatisticsSeller[];
    contentProvider?: number;
    contentProviderOptions?: IStatisticsContentProvider[];
    periodDates: IPeriodDate[];
    invoicedOnly: boolean;
    includeRemoved: boolean;
    compareWithLastYear: boolean;
    changeValue(e: any): void;
    handleCheckboxChange(e: any);
    onDateTimeChange(e: any, name: string);
}

const StatisticsFilter = (props: IStatisticsFilter) => {
    return (
        <fieldset>
            <legend>{Translate('statistics/page/fieldset/filter/legend')}</legend>
            <Row>
                <Col md={9}>
                    <Row>
                        <Col md={4}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('statistics/page/fieldset/filter/region/label')}
                                </ControlLabel>
                                <FormSelect
                                    name="filters.region"
                                    value={props.region ? props.region.toString() : ''}
                                    onChange={props.changeValue}
                                >
                                    <option value="">
                                        {Translate(
                                            'statistics/page/fieldset/filter/region/default'
                                        )}
                                    </option>
                                    {props.regions
                                        .sort((a, b) => {
                                            if (a.name > b.name) return 1;

                                            if (a.name < b.name) return -1;

                                            return 0;
                                        })
                                        .map((r: IStatisticsRegion) => {
                                            return (
                                                <option key={'region-' + r.id} value={r.id}>
                                                    {r.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate(
                                        'statistics/page/fieldset/filter/photographer/label'
                                    )}
                                </ControlLabel>
                                <FormSelect
                                    name="filters.photographer"
                                    value={props.photographer ? props.photographer.toString() : ''}
                                    onChange={props.changeValue}
                                >
                                    <option value="">
                                        {Translate(
                                            'statistics/page/fieldset/filter/photographer/default'
                                        )}
                                    </option>
                                    {props.photographers
                                        .sort((a, b) => {
                                            if (a.name > b.name) return 1;

                                            if (a.name < b.name) return -1;

                                            return 0;
                                        })
                                        .map((r: IStatisticsPhotographer) => {
                                            return (
                                                <option key={'photographer' + r.id} value={r.id}>
                                                    {r.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('statistics/page/fieldset/filter/chain/label')}
                                </ControlLabel>
                                <FormSelect
                                    name="filters.chain"
                                    value={props.chain ? props.chain.toString() : ''}
                                    onChange={props.changeValue}
                                >
                                    <option value="">
                                        {Translate('statistics/page/fieldset/filter/chain/default')}
                                    </option>
                                    {props.chains
                                        .sort((a, b) => {
                                            if (a.name > b.name) return 1;

                                            if (a.name < b.name) return -1;

                                            return 0;
                                        })
                                        .map((r: IStatisticsChain) => {
                                            return (
                                                <option key={'chain-' + r.id} value={r.id}>
                                                    {r.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('statistics/page/fieldset/filter/firm/label')}
                                </ControlLabel>
                                <FormSelect
                                    name="filters.firm"
                                    value={props.firm ? props.firm.toString() : ''}
                                    onChange={props.changeValue}
                                >
                                    <option value="">
                                        {Translate('statistics/page/fieldset/filter/firm/default')}
                                    </option>
                                    {props.firms
                                        .sort((a, b) => {
                                            if (a.name > b.name) return 1;

                                            if (a.name < b.name) return -1;

                                            return 0;
                                        })
                                        .map((r: IStatisticsFirm) => {
                                            return (
                                                <option key={'firm-' + r.id} value={r.id}>
                                                    {r.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        {props.periodDates &&
                            props.periodDates.map((x, i) => (
                                <span key={'period-date-' + i}>
                                    <Col md={4}>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'statistics/page/fieldset/filter/created-start/label'
                                                )}
                                            </ControlLabel>
                                            <DateTime
                                                locale={moment.locale()}
                                                input={true}
                                                onChange={(value) =>
                                                    props.onDateTimeChange(
                                                        value,
                                                        `filters.periodDates.${i}.start`
                                                    )
                                                }
                                                timeFormat={false}
                                                value={x.start}
                                                isValidDate={(date) => {
                                                    return x.end !== null
                                                        ? date.isSameOrBefore(x.end)
                                                        : true;
                                                }}
                                                closeOnSelect={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'statistics/page/fieldset/filter/created-end/label'
                                                )}
                                            </ControlLabel>
                                            <DateTime
                                                locale={moment.locale()}
                                                input={true}
                                                onChange={(value) =>
                                                    props.onDateTimeChange(
                                                        value,
                                                        `filters.periodDates.${i}.end`
                                                    )
                                                }
                                                timeFormat={false}
                                                value={x.end}
                                                isValidDate={(date) => {
                                                    return x.start !== null
                                                        ? date.isSameOrAfter(x.start)
                                                        : true;
                                                }}
                                                closeOnSelect={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </span>
                            ))}
                    </Row>
                </Col>
                <Col md={3}>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('statistics/page/fieldset/filter/seller/label')}
                                </ControlLabel>
                                <FormSelect
                                    name="filters.seller"
                                    value={props.seller ? props.seller.toString() : ''}
                                    onChange={props.changeValue}
                                >
                                    <option value="">
                                        {Translate(
                                            'statistics/page/fieldset/filter/seller/default'
                                        )}
                                    </option>
                                    {props.sellers
                                        .sort((a, b) => {
                                            if (a.name > b.name) return 1;

                                            if (a.name < b.name) return -1;

                                            return 0;
                                        })
                                        .map((r: IStatisticsSeller) => {
                                            return (
                                                <option key={'seller-' + r.id} value={r.id}>
                                                    {r.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('statistics/page/fieldset/filter/content-provider/label')}
                                </ControlLabel>
                                <FormSelect
                                    name="filters.contentProvider"
                                    value={props.contentProvider !== undefined && props.contentProvider !== null ? String(props.contentProvider) : ''}
                                    onChange={props.changeValue}
                                >
                                    <option value="">
                                        {Translate('statistics/page/fieldset/filter/content-provider/default')}
                                    </option>
                                    <option value="-1">
                                        {Translate('statistics/page/fieldset/filter/content-provider/without-content-provider')}
                                    </option>
                                    {Array.isArray(props.contentProviderOptions) && props.contentProviderOptions
                                        .sort((a, b) => {
                                            if (a.name > b.name) return 1;
                                            if (a.name < b.name) return -1;
                                            return 0;
                                        })
                                        .map((cp) => (
                                            <option key={'content-provider-' + cp.id} value={String(cp.id)}>
                                                {cp.name}
                                            </option>
                                        ))}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Checkbox
                                    name="filters.invoicedOnly"
                                    checked={props.invoicedOnly}
                                    onChange={props.handleCheckboxChange}
                                >
                                    <span>
                                        {Translate(
                                            'statistics/page/fieldset/filter/invoiced-only/label'
                                        )}{' '}
                                    </span>
                                </Checkbox>
                                <Checkbox
                                    name="filters.includeRemoved"
                                    checked={props.includeRemoved}
                                    onChange={props.handleCheckboxChange}
                                >
                                    <span>
                                        {Translate(
                                            'statistics/page/fieldset/filter/include-removed/label'
                                        )}
                                    </span>
                                </Checkbox>
                                <Checkbox
                                    name="filters.compareWithLastYear"
                                    checked={props.compareWithLastYear}
                                    onChange={props.handleCheckboxChange}
                                >
                                    <span>
                                        {Translate(
                                            'statistics/page/fieldset/filter/compare-with-last-year/label'
                                        )}
                                    </span>
                                </Checkbox>
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </fieldset>
    );
};

export default StatisticsFilter;
